<template>
  <div class="overflow-auto">
    <table
      class="table table-xs md:table-sm xl:table-md"
      v-if="invoices.length"
    >
      <thead>
        <tr>
          <th>#</th>
          <th>{{ __("Title") }}</th>
          <th>{{ __("Amount") }}</th>
          <th>{{ __("Type") }}</th>
          <th>{{ __("Status") }}</th>
          <th>{{ __("User") }}</th>
          <th>{{ __("Created At") }}</th>
          <th>{{ __("Action") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in invoices">
          <td>{{ (meta.per_page ?? 1) * ((meta.current_page ?? 1) - 1) + index + 1 }}</td>
          <td>{{ item.title }}</td>
          <td>{{ item.amount.currency(item.currency) }}</td>
          <td>{{ __(item.type?.capitalize() + ' ' + 'invoice') }}</td>
          <td
            :class="{
              'text-success': item.status == 'paid',
              'text-success': item.status == 'valid',
              'text-error': item.status == 'canceled',
              'text-error': item.status == 'expired',
            }"
          >
            {{ __(item.status?.replace("_", " ")?.capitalize()) }}
          </td>
          <td>{{ item.user }}</td>
          <td>{{ item.created_at }}</td>
          <td>
            <router-link
              :to="{ name: 'user.invoice.show', params: { id: item.id } }"
              :class="{
                'btn-disabled':
                  !can('invoice.view.all') &&
                  !can('invoice.view.self', item.self),
              }"
              class="btn btn-outline btn-primary btn-sm ml-2"
            >
              {{ __("Show") }}
            </router-link>
            <router-link
              :to="{ name: 'user.invoice.edit', params: { id: item.id } }"
              :class="{
                'btn-disabled':
                  !can('invoice.edit.all') &&
                  !can('invoice.edit.self', item.self),
              }"
              class="btn btn-outline btn-info btn-sm ml-2"
            >
              {{ __("Edit") }}
            </router-link>
            <label
              @click="setItem(item)"
              for="invoice-delete-modal"
              :class="{
                'btn-disabled':
                  !can('invoice.delete.all') &&
                  !can('invoice.delete.self', item.self),
              }"
              class="btn btn-outline btn-error btn-sm"
            >
              {{ __("Delete") }}
            </label>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="col-span-12 flex flex-col items-center mt-9" v-else>
      <NotFound />
    </div>
  </div>
</template>
<script setup>
const {
  meta,
} = useDashboard();
defineProps(["invoices"]);
const emit = defineEmits(["setItem"]);
const setItem = (item) => emit("setItem", item);
</script>
